/**
 * Soccer :: Perform :: API 1.0.0
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class TournamentCalendarsApi extends runtime.BaseAPI {
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-season-expected-goals.htm\">Perform Documentation - TM9</a>
     * Returns the TM9 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonexpectedgoalsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonexpectedgoalsGet.');
        }
        if (requestParameters.contestantId === null ||
            requestParameters.contestantId === undefined) {
            throw new runtime.RequiredError('contestantId', 'Required parameter requestParameters.contestantId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonexpectedgoalsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/contestants/{contestantId}/seasonexpectedgoals`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'contestantId'}}`, String(requestParameters.contestantId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-season-expected-goals.htm\">Perform Documentation - TM9</a>
     * Returns the TM9 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonexpectedgoalsGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonexpectedgoalsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-season-expected-goals.htm\">Perform Documentation - TM9</a>
     * Returns a snapshot of the TM9 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonexpectedgoalsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonexpectedgoalsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.contestantId === null ||
            requestParameters.contestantId === undefined) {
            throw new runtime.RequiredError('contestantId', 'Required parameter requestParameters.contestantId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonexpectedgoalsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonexpectedgoalsSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/contestants/{contestantId}/seasonexpectedgoals/snapshots/{snapshotId}`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'contestantId'}}`, String(requestParameters.contestantId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-season-expected-goals.htm\">Perform Documentation - TM9</a>
     * Returns a snapshot of the TM9 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonexpectedgoalsSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonexpectedgoalsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-season-player-ratings.htm\">Perform Documentation - TM10</a>
     * Returns the TM10 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonplayerratingsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonplayerratingsGet.');
        }
        if (requestParameters.contestantId === null ||
            requestParameters.contestantId === undefined) {
            throw new runtime.RequiredError('contestantId', 'Required parameter requestParameters.contestantId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonplayerratingsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/contestants/{contestantId}/seasonplayerratings`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'contestantId'}}`, String(requestParameters.contestantId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-season-player-ratings.htm\">Perform Documentation - TM10</a>
     * Returns the TM10 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonplayerratingsGet(requestParameters, initOverrides) {
        await this.performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonplayerratingsGetRaw(requestParameters, initOverrides);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-seasonal-stats.htm\">Perform Documentation - TM4</a>
     * Returns the TM4 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonstatsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonstatsGet.');
        }
        if (requestParameters.contestantId === null ||
            requestParameters.contestantId === undefined) {
            throw new runtime.RequiredError('contestantId', 'Required parameter requestParameters.contestantId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonstatsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/contestants/{contestantId}/seasonstats`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'contestantId'}}`, String(requestParameters.contestantId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-seasonal-stats.htm\">Perform Documentation - TM4</a>
     * Returns the TM4 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonstatsGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonstatsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-seasonal-stats.htm\">Perform Documentation - TM4</a>
     * Returns a snapshot of the TM4 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonstatsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonstatsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.contestantId === null ||
            requestParameters.contestantId === undefined) {
            throw new runtime.RequiredError('contestantId', 'Required parameter requestParameters.contestantId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonstatsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonstatsSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/contestants/{contestantId}/seasonstats/snapshots/{snapshotId}`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'contestantId'}}`, String(requestParameters.contestantId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-seasonal-stats.htm\">Perform Documentation - TM4</a>
     * Returns a snapshot of the TM4 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonstatsSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSeasonstatsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-squads.htm\">Perform Documentation - TM3</a>
     * Returns the TM3 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSquadsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSquadsGet.');
        }
        if (requestParameters.contestantId === null ||
            requestParameters.contestantId === undefined) {
            throw new runtime.RequiredError('contestantId', 'Required parameter requestParameters.contestantId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSquadsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/contestants/{contestantId}/squads`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'contestantId'}}`, String(requestParameters.contestantId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-squads.htm\">Perform Documentation - TM3</a>
     * Returns the TM3 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSquadsGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSquadsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-squads.htm\">Perform Documentation - TM3</a>
     * Returns a snapshot of the TM3 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSquadsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSquadsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.contestantId === null ||
            requestParameters.contestantId === undefined) {
            throw new runtime.RequiredError('contestantId', 'Required parameter requestParameters.contestantId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSquadsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSquadsSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/contestants/{contestantId}/squads/snapshots/{snapshotId}`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'contestantId'}}`, String(requestParameters.contestantId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-squads.htm\">Perform Documentation - TM3</a>
     * Returns a snapshot of the TM3 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSquadsSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdContestantsContestantIdSquadsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-teams.htm\">Perform Documentation - TM1</a>
     * Returns the TM1 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/contestants`.replace(`{${'calendarId'}}`, String(requestParameters.calendarId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-teams.htm\">Perform Documentation - TM1</a>
     * Returns the TM1 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdContestantsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-teams.htm\">Perform Documentation - TM1</a>
     * Returns a snapshot of the TM1 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdContestantsSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/contestants/snapshots/{snapshotId}`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-teams.htm\">Perform Documentation - TM1</a>
     * Returns a snapshot of the TM1 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdContestantsSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdContestantsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-injuries.htm\">Perform Documentation - PE7</a>
     * Returns the PE7 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdInjuriesGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdInjuriesGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/injuries`.replace(`{${'calendarId'}}`, String(requestParameters.calendarId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-injuries.htm\">Perform Documentation - PE7</a>
     * Returns the PE7 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdInjuriesGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdInjuriesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-injuries.htm\">Perform Documentation - PE7</a>
     * Returns a snapshot of the PE7 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdInjuriesSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdInjuriesSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdInjuriesSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/injuries/snapshots/{snapshotId}`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-injuries.htm\">Perform Documentation - PE7</a>
     * Returns a snapshot of the PE7 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdInjuriesSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdInjuriesSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-rankings.htm\">Perform Documentation - PE4</a>
     * Returns the PE4 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdRankingsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdRankingsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/rankings`.replace(`{${'calendarId'}}`, String(requestParameters.calendarId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-rankings.htm\">Perform Documentation - PE4</a>
     * Returns the PE4 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdRankingsGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdRankingsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-rankings.htm\">Perform Documentation - PE4</a>
     * Returns a snapshot of the PE4 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdRankingsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdRankingsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdRankingsSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/rankings/snapshots/{snapshotId}`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-rankings.htm\">Perform Documentation - PE4</a>
     * Returns a snapshot of the PE4 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdRankingsSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdRankingsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-referees.htm\">Perform Documentation - PE3</a>
     * Returns the PE3 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdRefereesGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdRefereesGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/referees`.replace(`{${'calendarId'}}`, String(requestParameters.calendarId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-referees.htm\">Perform Documentation - PE3</a>
     * Returns the PE3 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdRefereesGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdRefereesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-referees.htm\">Perform Documentation - PE3</a>
     * Returns a snapshot of the PE3 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdRefereesSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdRefereesSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdRefereesSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/referees/snapshots/{snapshotId}`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-referees.htm\">Perform Documentation - PE3</a>
     * Returns a snapshot of the PE3 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdRefereesSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdRefereesSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-squads.htm\">Perform Documentation - TM3</a>
     * Returns the TM3 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdSquadsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdSquadsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/squads`.replace(`{${'calendarId'}}`, String(requestParameters.calendarId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-squads.htm\">Perform Documentation - TM3</a>
     * Returns the TM3 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdSquadsGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdSquadsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-squads.htm\">Perform Documentation - TM3</a>
     * Returns a snapshot of the TM3 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdSquadsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdSquadsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdSquadsSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/squads/snapshots/{snapshotId}`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-squads.htm\">Perform Documentation - TM3</a>
     * Returns a snapshot of the TM3 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdSquadsSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdSquadsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-team-standings.htm\">Perform Documentation - TM2</a>
     * Returns the TM2 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdStandingsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdStandingsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/standings`.replace(`{${'calendarId'}}`, String(requestParameters.calendarId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-team-standings.htm\">Perform Documentation - TM2</a>
     * Returns the TM2 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdStandingsGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdStandingsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-team-standings.htm\">Perform Documentation - TM2</a>
     * Returns a snapshot of the TM2 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdStandingsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdStandingsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdStandingsSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/standings/snapshots/{snapshotId}`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-team-standings.htm\">Perform Documentation - TM2</a>
     * Returns a snapshot of the TM2 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdStandingsSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdStandingsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-suspensions.htm\">Perform Documentation - PE8</a>
     * Returns the PE8 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdSuspensionsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdSuspensionsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/suspensions`.replace(`{${'calendarId'}}`, String(requestParameters.calendarId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-suspensions.htm\">Perform Documentation - PE8</a>
     * Returns the PE8 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdSuspensionsGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdSuspensionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-suspensions.htm\">Perform Documentation - PE8</a>
     * Returns a snapshot of the PE8 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdSuspensionsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdSuspensionsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdSuspensionsSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/suspensions/snapshots/{snapshotId}`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-suspensions.htm\">Perform Documentation - PE8</a>
     * Returns a snapshot of the PE8 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdSuspensionsSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdSuspensionsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-top-performers.htm\">Perform Documentation - PE6</a>
     * Returns the PE6 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdTopperformersGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdTopperformersGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/topperformers`.replace(`{${'calendarId'}}`, String(requestParameters.calendarId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-top-performers.htm\">Perform Documentation - PE6</a>
     * Returns the PE6 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdTopperformersGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdTopperformersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-top-performers.htm\">Perform Documentation - PE6</a>
     * Returns a snapshot of the PE6 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdTopperformersSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdTopperformersSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdTopperformersSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/topperformers/snapshots/{snapshotId}`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-top-performers.htm\">Perform Documentation - PE6</a>
     * Returns a snapshot of the PE6 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdTopperformersSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdTopperformersSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-tournament-schedule.htm\">Perform Documentation</a>
     * Returns the MA0 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdTournamentscheduleGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdTournamentscheduleGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/tournamentschedule`.replace(`{${'calendarId'}}`, String(requestParameters.calendarId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-tournament-schedule.htm\">Perform Documentation</a>
     * Returns the MA0 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdTournamentscheduleGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdTournamentscheduleGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-tournament-schedule.htm\">Perform Documentation</a>
     * Returns a snapshot of the MA0 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdTournamentscheduleSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdTournamentscheduleSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdTournamentscheduleSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/tournamentschedule/snapshots/{snapshotId}`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-tournament-schedule.htm\">Perform Documentation</a>
     * Returns a snapshot of the MA0 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdTournamentscheduleSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdTournamentscheduleSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-transfers.htm\">Perform Documentation - TM7</a>
     * Returns the TM7 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdTransfersGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdTransfersGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/transfers`.replace(`{${'calendarId'}}`, String(requestParameters.calendarId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-transfers.htm\">Perform Documentation - TM7</a>
     * Returns the TM7 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdTransfersGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdTransfersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-transfers.htm\">Perform Documentation - TM7</a>
     * Returns a snapshot of the TM7 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdTransfersSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.calendarId === null ||
            requestParameters.calendarId === undefined) {
            throw new runtime.RequiredError('calendarId', 'Required parameter requestParameters.calendarId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdTransfersSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataTournamentCalendarsCalendarIdTransfersSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/tournamentCalendars/{calendarId}/transfers/snapshots/{snapshotId}`
                .replace(`{${'calendarId'}}`, String(requestParameters.calendarId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-transfers.htm\">Perform Documentation - TM7</a>
     * Returns a snapshot of the TM7 feed
     */
    async performSoccerdataTournamentCalendarsCalendarIdTransfersSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataTournamentCalendarsCalendarIdTransfersSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=TournamentCalendarsApi.js.map